import { UnitType } from '@exodus/currency'

const name = 'monero'
const displayName = 'Monero'
const ticker = 'XMR'
const displayTicker = ticker
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#FA6800'
const gradientColors = ['#FA6800', '#9B4202']
const gradientCoords = { x1: '22.351%', y1: '-12.223%', x2: '98.837%', y2: '152.777%' }
const chainBadgeColors = gradientColors

const units = {
  atomic: 0,
  XMR: 12,
}
const currency = UnitType.create(units)

const assetType = 'BITCOIN_LIKE'
const blockExplorer = {
  addressUrl: (address) =>
    'https://support.exodus.io/article/1035-why-can-i-not-view-address-details-for-monero',
  txUrl: (txId) => `https://www.monerochain.com/tx/${txId}`,
  receiptUrl: (txId, address, txKey) =>
    `https://www.exploremonero.com/receipt/${txId}/${address}/${txKey}`,
}
const info = {
  description:
    'Monero is a cryptocurrency with a privacy focus. Transactions on the Monero network are designed to be hidden and untraceable.',
  reddit: 'https://www.reddit.com/r/Monero/',
  twitter: 'https://twitter.com/monero/',
  website: 'https://getmonero.org/',
}

export const tokens = undefined
export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export default [asset]
